import { Box, Grid, Typography } from '@mui/material'
import { AppContainer } from 'components/AppContainer'
import {
  StyledFormWrapper,
  StyledGrid,
  StyledImage,
  StyledLoginWrap,
  StyledPaperRoot
} from './styled'
import loginImage from 'img/login.jpg'
import { AuthorizationButton } from 'components/Auth/AuthorizationButton'
import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import { useWpAuthContext } from 'services/auth/WpAuthProvider'
import { Loader } from 'components/Loader'
import { useEffect, useState } from 'react'
import { jwtDecode } from 'jwt-decode'
import { Navigate } from 'react-router-dom'
import { getLocalStorageData } from 'utils/localStorage'

export const LoginPage = () => {
  const { isAuthenticated, isLoading } = useKindeAuth()
  const { authUser } = useWpAuthContext()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const userSession = getLocalStorageData('user_data')

  useEffect(() => {
    if (isAuthenticated && !authUser) {
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }
  }, [isAuthenticated, authUser])

  if ((authUser || userSession) && isAuthenticated) {
    return <Navigate to="/dashboard" />
  }

  return (
    <AppContainer>
      <StyledPaperRoot elevation={0}>
        <Grid container position={'relative'}>
          <StyledGrid item xs={12} md={6} className="overlay">
            <StyledImage src={loginImage} alt="Login image" />
          </StyledGrid>

          <StyledFormWrapper item xs={12} md={6} position={'relative'}>
            {isLoggedIn && <Loader />}
            <StyledLoginWrap className={isLoggedIn ? 'hidden' : ''}>
              <Typography variant="h4" align="center">
                לצפיה ומעקב אחר ההתקדמות שלך
                <br />
                יש להירשם תחילה לאתר
              </Typography>
              <Box marginTop={2} width={{ xs: '100%', sm: '50%', md: 'auto' }}>
                <AuthorizationButton
                  type={isAuthenticated && !isLoggedIn ? 'logout' : 'login'}
                  mode="dark"
                  className="mobile"
                />
              </Box>
            </StyledLoginWrap>
          </StyledFormWrapper>
        </Grid>
      </StyledPaperRoot>
    </AppContainer>
  )
}
